import React from 'react';
import { ArrowDown, CornerDownRight, Clock3 } from 'lucide-react';

const FlowNode = ({ node, path = 'root', forked = false }) => <div className="mc-flow-subtree" data-testid={`visual-tree-${path}`}>
  <div className="mc-flow-node" data-testid={`visual-node-${path}`}>
    <strong data-testid={`visual-node-label-${path}`}>{node.label}</strong>
    {node.detail && <p data-testid={`visual-node-detail-${path}`}>{node.detail}</p>}
  </div>
  {!!node.children.length && <div data-testid={`visual-branches-${path}`} data-parent={node.label} data-branch-count={node.children.length} className={`mc-flow-children ${node.children.length > 1 ? `mc-flow-fork ${forked ? 'mc-flow-fork-nested' : ''}` : ''}`}>
    {node.children.map((child, index) => <div key={index} className="mc-flow-branch">
      <div className="mc-flow-connector" data-testid={`visual-edge-${path}-${index}`}>{node.children.length > 1 ? <CornerDownRight aria-hidden="true" size={26} /> : <ArrowDown aria-hidden="true" size={26} />}{child.relation && <span>{child.relation}</span>}</div>
      <FlowNode node={child} path={`${path}-${index}`} forked={forked || node.children.length > 1} />
    </div>)}
  </div>}
</div>;

export const GeneratedClinicalVisual = ({ data }) => {
  if (!data) return null;
  return <div className="mc-generated-visual" data-testid="generated-clinical-visual" data-visual-kind={data.kind}>
    <h3 data-testid="generated-visual-title" className="mc-generated-title">{data.title}</h3>
    {data.kind === 'algorithm' && <div data-testid="generated-clinical-algorithm"><FlowNode node={data.root} /></div>}
    {data.kind === 'table' && <>
      <table className="mc-generated-table" data-testid="generated-clinical-table">
        <thead><tr>{data.columns.map((column, i) => <th data-testid={`visual-column-${i}`} key={i} scope="col">{column}</th>)}</tr></thead>
        <tbody>{data.rows.map((row, i) => <tr key={i}>{row.map((cell, j) => j === 0
          ? <th data-testid={`visual-cell-${i}-${j}`} key={j} scope="row">{cell}</th>
          : <td data-testid={`visual-cell-${i}-${j}`} key={j}>{cell}</td>)}</tr>)}</tbody>
      </table>
      <dl className="mc-generated-mobile-table" data-testid="generated-clinical-table-mobile">
        {data.rows.map((row, i) => <div className="mc-mobile-table-row" key={i} data-testid={`visual-mobile-row-${i}`}>
          {row.map((cell, j) => <div key={j}><dt data-testid={`visual-mobile-label-${i}-${j}`}>{data.columns[j]}</dt><dd data-testid={`visual-mobile-cell-${i}-${j}`}>{cell}</dd></div>)}
        </div>)}
      </dl>
    </>}
    {data.kind === 'timeline' && <ol className="mc-generated-timeline" data-testid="generated-clinical-timeline">
      {data.events.map((event, i) => <li key={i} data-testid={`visual-event-${i}`}>
        <div className="mc-event-time"><Clock3 aria-hidden="true" size={22} /><strong data-testid={`visual-event-time-${i}`}>{event.time}</strong></div>
        <strong data-testid={`visual-event-title-${i}`}>{event.title}</strong><p data-testid={`visual-event-detail-${i}`}>{event.detail}</p>
      </li>)}
    </ol>}
    {!!data.review_notes?.length && <ul className="mc-visual-notes" data-testid="visual-clinical-notes">{data.review_notes.map((note, i) => <li key={i} data-testid={`visual-clinical-note-${i}`}>{note}</li>)}</ul>}
  </div>;
};